export default __webpack_public_path__ + "static/chronos-screenshot-1ad2b33b3c0545ff06a6815273466fb3.png";